import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const WorkspaceComponent = () => {
    return (
        <Box>
            <Outlet />
        </Box>
    );
};

export default WorkspaceComponent;
